import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function AnnouncementBar() {
  return (
    <div className="bg-navy text-white" data-testid="announcement-bar">
      <div className="container-page flex items-center justify-center gap-3 py-2.5 text-center">
        <p className="text-[12.5px] sm:text-[13px] text-white/85 leading-snug">
          Sourcing and trade coordination across China, the Middle East, USA and Europe.
        </p>
        <Link
          to="/request-a-quote"
          data-testid="announcement-cta"
          className="hidden sm:inline-flex items-center gap-1 text-[12.5px] font-semibold text-copper hover:text-white transition-colors whitespace-nowrap"
        >
          Discuss your requirement
          <ArrowRight className="h-3.5 w-3.5" aria-hidden="true" />
        </Link>
      </div>
    </div>
  );
}
